<template>
  <section>
    <div class="container clearfix py-5">
      <h1 class="text-center">Araştırmalar</h1>
      <h4 class="text-center">
        Görüntülemek istediğiniz araştırma dökümanını seçiniz.
      </h4>
      <div class="row justify-content-center">
        <div class="clear"></div>
        <div class="col-md-11 my-5">
          <div class="row">
            <div class="col-lg-6">
              <a
                download
                target="_blank"
                href="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/BG%20Ara%C5%9Ft%C4%B1rma.pdf?alt=media&token=13336c01-acf7-4583-8429-cfdac05baab5"
              >
                <h3 class="text-center text-danger">
                  <i class="icon icon-file-alt2 icon-3x"></i>
                  <br />Birlikte Güçlüyüz "İş Dünyası Aile İçi Şiddete Karşı"
                  Araştırması
                </h3>
              </a>
            </div>
            <div class="col-lg-6">
              <a
                download
                target="_blank"
                href="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/mgi-the-future-of-women-at-work-report.pdf?alt=media&token=4918bb30-a5b8-4064-abc0-22172a02d59d"
              >
                <h3 class="text-center text-danger">
                  <i class="icon icon-file-alt2 icon-3x"></i>
                  <br />MGI Future of The Women At Work Report
                </h3>
              </a>
            </div>
            <div class="col-lg-6">
              <a
                download
                target="_blank"
                href="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/kagider-danone--%C3%A7al%C4%B1%C5%9Fan-annelerin-i%C5%9Fe-d%C3%B6n%C3%BC%C5%9F%C3%BC--ara%C5%9Ft%C4%B1rma-sonu%C3%A7lar%C4%B1.pdf?alt=media&token=7eedd015-c366-4109-b17e-9cd2224800a4"
              >
                <h3 class="text-center text-danger">
                  <i class="icon icon-file-alt2 icon-3x"></i>
                  <br />KAGİDER Danone "İşe Dönüş" Araştırması
                </h3>
              </a>
            </div>
            <div class="col-lg-6">
              <a
                download
                target="_blank"
                href="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/iletisimde-tce-kilavuzu.pdf?alt=media&token=363da9f6-bb17-4ec6-9257-81d76cbce1c3"
              >
                <h3 class="text-center text-danger">
                  <i class="icon icon-file-alt2 icon-3x"></i>
                  <br />İletişimde TCE Kılavuzu
                </h3>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
